import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Plus, Trash2, Ban, ShieldCheck, Mail, BadgeCheck, Pencil } from "lucide-react";
import { statusBadge, codeBadge, outlineBtn, dangerBtn } from "./shared";

const MembersTab = ({ members, onAdd, openEdit, approve, setStatus, resendMember, deleteMember }) => (
  <>
    <div className="flex justify-end mb-4">
      <Button onClick={onAdd} className="bg-[var(--ir-orange)] hover:bg-[var(--ir-orange-soft)] text-white font-semibold rounded-none" data-testid="add-member-btn">
        <Plus className="w-4 h-4 mr-2" />Add Member
      </Button>
    </div>
    <div className="bg-white border border-[var(--ir-border)] rounded-lg overflow-x-auto soft-shadow">
      <Table>
        <TableHeader>
          <TableRow className="border-[var(--ir-border)] hover:bg-transparent">
            <TableHead className="text-[var(--ir-muted)]">Member</TableHead>
            <TableHead className="text-[var(--ir-muted)]">Status</TableHead>
            <TableHead className="text-[var(--ir-muted)]">Access Code</TableHead>
            <TableHead className="text-[var(--ir-muted)] text-right">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {members.length === 0 && (
            <TableRow className="border-[var(--ir-border)]"><TableCell colSpan={4} className="text-center text-[var(--ir-muted)] py-10">No members yet.</TableCell></TableRow>
          )}
          {members.map((m) => (
            <TableRow key={m.id} className="border-[var(--ir-border)] hover:bg-[var(--ir-surface2)]/50" data-testid={`member-row-${m.id}`}>
              <TableCell>
                <div className="font-medium text-[var(--ir-text)] flex items-center gap-2">
                  {m.name}
                  {m.is_affiliate && <Badge className="rounded-none border bg-[var(--ir-orange)]/10 text-[var(--ir-orange)] border-[var(--ir-orange)]/30 text-[10px]"><BadgeCheck className="w-3 h-3 mr-1" />Affiliate</Badge>}
                </div>
                <div className="text-[var(--ir-muted)] text-sm">{m.email}</div>
                {m.phone && <div className="text-[var(--ir-muted)] text-xs">{m.phone}</div>}
                {m.referred_by_name && <div className="text-[var(--ir-blue)] text-xs mt-0.5">Referred by {m.referred_by_name}</div>}
              </TableCell>
              <TableCell>{statusBadge(m.status)}</TableCell>
              <TableCell>
                <div className="flex items-center gap-2">
                  <span className="font-mono text-[var(--ir-text)]">{m.access_code || "—"}</span>
                  {codeBadge(m)}
                </div>
              </TableCell>
              <TableCell>
                <div className="flex items-center justify-end gap-2 flex-wrap">
                  <Button size="sm" variant="outline" onClick={() => openEdit(m)} className={outlineBtn} data-testid={`edit-member-btn-${m.id}`}>
                    <Pencil className="w-3.5 h-3.5 mr-1" />Edit
                  </Button>
                  {m.status !== "approved" ? (
                    <Button size="sm" onClick={() => approve(m.id)} className="bg-emerald-500 hover:bg-emerald-600 text-white rounded-none h-8" data-testid={`approve-btn-${m.id}`}>
                      <ShieldCheck className="w-3.5 h-3.5 mr-1" />Approve
                    </Button>
                  ) : (
                    <Button size="sm" variant="outline" onClick={() => setStatus(m.id, "suspended")} className={dangerBtn} data-testid={`suspend-btn-${m.id}`}>
                      <Ban className="w-3.5 h-3.5 mr-1" />Suspend
                    </Button>
                  )}
                  {m.access_code && (
                    <Button size="sm" variant="outline" onClick={() => resendMember(m.id)} className={outlineBtn} title="Resend welcome email" data-testid={`resend-member-btn-${m.id}`}>
                      <Mail className="w-3.5 h-3.5" />
                    </Button>
                  )}
                  <Button size="sm" variant="outline" onClick={() => deleteMember(m.id)} className={dangerBtn} data-testid={`delete-member-btn-${m.id}`}>
                    <Trash2 className="w-3.5 h-3.5" />
                  </Button>
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  </>
);

export default MembersTab;
